import VueGtag from "vue-gtag-next";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  nuxtApp.vueApp.use(VueGtag, {
    property: [
      {
        id: config.public.googleAnalytics1Id,
        params: {
          linker: {
            domain: [config.public.googleAnalytics1LinkerDomain],
          },
        },
      },
      {
        id: config.public.googleAnalytics2Id,
        params: {
          cookie_prefix: config.public.googleAnalytics2CookiePrefix,
        },
      },
    ],
  });
});
